import { styled } from 'styled-components';

export const ImageLogo = styled.img`
    max-width: 100%;
`;
